import { useEffect } from "react";
import { type HTTPErrors, matchHttpError } from "../../../errors";
import { useErrorDispatcher } from "../../../hooks/useErrorDispatcher";

// モーダルの中の参照（コースの取得・生徒の検索）の失敗のうち、401・メンテナンス・緊急停止は、
// 起票の POST と同じく既存の共通処理に渡す（401 ならログインの画面に移る）。
// それ以外の失敗は、モーダルの中で文言を示すため、ここでは扱わない
export const useSendCommonQueryError = (error: HTTPErrors | null) => {
  const { sendUnauthorized, sendSteakEmergencyError, sendMaintenanceError } =
    useErrorDispatcher();

  useEffect(() => {
    if (!error) {
      return;
    }
    matchHttpError(error, {
      caseUnauthorized: sendUnauthorized,
      caseSteakEmergencyError: sendSteakEmergencyError,
      caseMaintenanceError: sendMaintenanceError,
    });
  }, [error, sendUnauthorized, sendSteakEmergencyError, sendMaintenanceError]);
};
